import { supabase } from '@/lib/supabase'

export async function getTrialDaysLeft(): Promise<number> {
  const { data, error } = await supabase.rpc('user_trial_days_left')
  if (error) {
    throw new Error(error.message || 'Falha ao carregar dias de teste restante')
  }
  const raw = data as any
  const n = Number(raw ?? 0)
  if (!Number.isFinite(n) || n <= 0) return 0
  return Math.floor(n)
}

